module.exports = __webpack_public_path__ + "img/yoga-off-pico_banner.d74a5d0e.png";